import React from "react";
import { PrismicPreviewProvider } from "gatsby-plugin-prismic-previews";
import { linkResolver } from "./src/utils/linkResolver";

const wrapRootElement = ({ element }) => (
  <PrismicPreviewProvider
    repositoryConfigs={[
      {
        repositoryName: "ux-portfolio",
        linkResolver,
      },
    ]}
  >
    {element}
  </PrismicPreviewProvider>
);

export default wrapRootElement;
